import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URLS } from "../../constants";

const Register = () => {
  const [userData, setUserData] = useState({ username: "", password: "", name: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${API_URLS.API_ACCOUNTS_URL}register/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });

    if (response.ok) {
      alert("회원가입 성공! 로그인 해주세요.");
      navigate("/login");
    } else {
      alert("회원가입 실패");
    }
  };

  return (
    <div className="container">
      <h2>회원가입</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" name="username" className="form-control mb-2" placeholder="아이디" onChange={handleChange} />
        <input type="text" name="name" className="form-control mb-2" placeholder="이름" onChange={handleChange} />
        <input type="password" name="password" className="form-control mb-2" placeholder="비밀번호" onChange={handleChange} />
        <button type="submit" className="btn btn-primary">회원가입</button>
      </form>
    </div>
  );
};

export default Register;
